import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import { PhHourglassMedium } from 'ember-phosphor-icons';
import HeroStat from 'tio-employee/components/dashboard-kit/hero-stat';
import {
  daysWaiting,
  type QueueSnapshot,
} from 'tio-employee/utils/partner-dashboard/sources/approval-queue';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Hero tile: how many queue items are waiting on the viewer, and how long the oldest has waited. */
export default class WaitingOnYouWidget extends Component<WidgetComponentSignature<QueueSnapshot>> {
  @service declare intl: IntlService;

  get context() {
    const { total, oldest } = this.args.data.waitingOnYou;
    if (!total) return this.intl.t('partner_dashboard.queue.nothing_waiting');
    const days = daysWaiting(oldest[0]?.waitingSince);
    return days === null
      ? this.intl.t('partner_dashboard.queue.open_queue')
      : this.intl.t('partner_dashboard.queue.oldest_waiting', { count: days });
  }

  <template>
    <HeroStat
      @emphasis="metric"
      @label={{t "partner_dashboard.queue.waiting_on_you"}}
      @value={{@data.waitingOnYou.total}}
      @context={{this.context}}
      @contextIcon={{PhHourglassMedium}}
      data-test-partner-dashboard-waiting-on-you
    />
  </template>
}
